<template>
    <div>
        <div class="pane-content" style="display:flex;align-items:stretch;gap:16px;height:calc(100vh - 150px);min-height:620px;padding:0 16px;box-sizing:border-box;">
            <div class="content-params" v-if="cndjInfo" style="width:620px;min-width:620px;flex:0 0 620px;overflow-y:auto;box-sizing:border-box;">
                <div class="feature-panel">
                    <div class="feature-title">特征值</div>
                    <table class="feature-table">
                        <thead>
                            <tr>
                                <th>参数</th>
                                <th>值</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in motorFeatureRows" :key="row.key">
                                <td>{{ row.label }}</td>
                                <td>
                                    <div class="table-value">
                                        <span>{{ row.value }}</span>
                                        <span v-if="row.statusDirection" :class="['range-arrow', 'range-arrow-' + row.statusDirection, 'range-arrow-level-' + row.level]"></span>
                                    </div>
                                    <div class="table-range" v-if="showRange && row.range">{{ row.range }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <div class="title"><h3>特征参数</h3></div> -->
                <div class="details">
                    <div class="details-item">
                        <div class="item-label">电机储能时间</div> <div class="item-value">{{ cndjInfo.create_date?cndjInfo.create_date:'-'}}</div>
                    </div> 
                    <div class="details-item">
                        <div class="item-label"></div> <div class="item-value"></div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">电机运行时间</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_dt != null ? cndjInfo.Mech_Results.Motor.MO_dt/1000 + ' s' : '-'}}</span>
                                <span v-if="cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_dt != null" :class="['status-dot', getAlarmStatus(cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dt&&cndjInfo.Motor_Alarm_level.Motor.MO_dt.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dt&&cndjInfo.Motor_Alarm_level.Motor.MO_dt.warn_min || '-' }}~{{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dt&&cndjInfo.Motor_Alarm_level.Motor.MO_dt.warn_max || '-' }}s)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">电机启动电流</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_FI != null ? cndjInfo.Mech_Results.Motor.MO_FI + ' A' : '-'}}</span>
                                <span v-if="cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_FI != null" :class="['status-dot', getAlarmStatus(cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_FI&&cndjInfo.Motor_Alarm_level.Motor.MO_FI.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_FI&&cndjInfo.Motor_Alarm_level.Motor.MO_FI.warn_min || '-' }}~{{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_FI&&cndjInfo.Motor_Alarm_level.Motor.MO_FI.warn_max || '-' }}A)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">电机最大电流</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_MAXI != null ? cndjInfo.Mech_Results.Motor.MO_MAXI + ' A' : '-'}}</span>
                                <span v-if="cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_MAXI != null" :class="['status-dot', getAlarmStatus(cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI.warn_min || '-' }}~{{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI&&cndjInfo.Motor_Alarm_level.Motor.MO_MAXI.warn_max || '-' }}A)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">电机储能次数</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_dc != null ? cndjInfo.Mech_Results.Motor.MO_dc + ' 次' : '-'}}</span>
                                <span v-if="cndjInfo.Mech_Results&&cndjInfo.Mech_Results.Motor&&cndjInfo.Mech_Results.Motor.MO_dc != null" :class="['status-dot', getAlarmStatus(cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dc&&cndjInfo.Motor_Alarm_level.Motor.MO_dc.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dc&&cndjInfo.Motor_Alarm_level.Motor.MO_dc.warn_min || '-' }}~{{ cndjInfo.Motor_Alarm_level&&cndjInfo.Motor_Alarm_level.Motor&&cndjInfo.Motor_Alarm_level.Motor.MO_dc&&cndjInfo.Motor_Alarm_level.Motor.MO_dc.warn_max || '-' }}次)</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-chart" style="flex:1 1 auto;min-width:0;height:100%;">
                <div class="item-tips" v-if="!cndjInfo.create_date">无电机数据</div>
                <div id="switch" ref="switch" class="switch" style="width:100%;height:100%;min-height:620px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import * as device from '@/data/device.js'
import * as file from '@/data/file.js'
export default {
    name: "",
    props:{
        dataDetails:{
            type:Object,
            default:()=>{}
        },
        showRange:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            switchChart: null,
            option: {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}(s) <br/>{a} : {c} (A)'
                },
                title: {
                    left:'center',
                    text: '电机电流',
                    textStyle: {
                        color: '#b5b5b5ff',
                        fontSize:13
                    }
                },
                toolbox: {
                    show: 1, 
                    x: 'right', 
                    y: 'top', 
                    itemSize: 14,
                    itemGap: 8,
                    feature: {
                        dataZoom: [
                            { 
                                type: 'inside',
                                show: true, 
                                realtime: true,                                                               
                                start: 0,  
                                end: 100,
                                iconStyle: {
                                    borderColor: '#FFFFFF',
                                }
                            },
                            {
                                type: 'inside',
                                realtime: true,
                                start: 0,
                                end: 100,
                                iconStyle: {
                                    borderColor: '#FFFFFF',
                                }
                            }
                        ],
                        restore: {
                            show: true, // 显示还原按钮
                            title: '还原',
                            iconStyle: {
                                borderColor: "#FFFFFF"
                            }
                        },
                        saveAsImage: {
                            show: true, 
                            title: '保存截图',
                            type: 'jpg',
                            backgroundColor: '#000000',
                            iconStyle: {
                                borderColor: "#FFFFFF",
                            }
                        }
                    },
                    iconStyle: {
                    borderColor: '#ffffff'
                    }
                },
                dataZoom: [
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                        filterMode: 'filter'
                    },
                    {
                        type: 'inside',
                        // yAxisIndex: 0,
                        filterMode: 'filter'
                    }
                ],
                grid: {
                    top: '40px',
                    right: '20px',
                    left: '80px',
                    bottom: '30px'
                },
                xAxis: {
                    type: 'category',
                    name: '时间(s)',
                    nameLocation: "center",
                    nameTextStyle: {
                        color:'#e1d8d8ff',
                        fontSize: 11
                    },
                    nameGap: 30,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisLabel: {
                        textStyle: {
                        color: '#8f8888ff',
                        fontSize: 10
                        },
                        hideOverlap: true,
                        margin: 10,
                    },
                    axisTick: {
                        show: true
                    },
                    axisLine: {
                            show: true,
                            onZero: false, 
                            lineStyle: {
                                color: '#a3a3a3ff', 
                                width: 2
                            }
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '电机电流(A)',
                    nameLocation: "center",
                    nameTextStyle: {
                        color:'#e1d8d8ff',
                        fontSize: 11
                    },
                    nameGap: 50,
                    axisLabel: {
                        textStyle: {
                        color: '#8f8888ff',
                        fontSize: 10
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLine: {
                        show: true,
                        onZero: false, 
                        lineStyle: {
                            color: '#a3a3a3ff', 
                            width: 2
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                        color: 'rgba(200, 200, 200, 0.2)', // 网格线浅灰色，不干扰数据
                        type: 'dashed'
                        }
                    },
                },
                series: [
                    {
                        name:'电机电流',
                        data: [820, 932, 901, 934, 1290, 1330, 1320],
                        type: 'line',
                        smooth: true,
                        showSymbol: false
                    }
                ]
            },
            cndjInfo:{},
            chartInstance:{}
        };
    },
    mounted() {
        if(this.dataDetails && this.dataDetails.sensor_data_id){
          //历史数据机械特性电机电流
           this.getMechDjInfoById();
        }else{
           this.getCNDJInfo();
        }
    },
    watch: {
        dataDetails(newVal) {
            if(this.dataDetails && this.dataDetails.sensor_data_id){
            //历史数据机械特性电机电流
            this.getMechDjInfoById();
            }else{
            this.getCNDJInfo();
            }
        }
    },
    beforeDestroy() {
        this.setRenderLoading(false)
        if (this.switchChart) {
            this.switchChart.dispose()
            this.switchChart = null
        }
    },
    computed: {
        motorFeatureRows() {
            return [
                {
                    label: '电机储能时间',
                    key: 'time',
                    value: this.cndjInfo && this.cndjInfo.create_date ? this.cndjInfo.create_date : '-'
                },
                this.buildMotorFeatureRow('电机运行时间', 'MO_dt', ' s', value => value / 1000),
                this.buildMotorFeatureRow('电机启动电流', 'MO_FI', ' A'),
                this.buildMotorFeatureRow('电机最大电流', 'MO_MAXI', ' A'),
                this.buildMotorFeatureRow('电机储能次数', 'MO_dc', ' 次')
            ]
        }
    },
    methods: {
        setRenderLoading(val) {
            this.$emit('loading-change', val)
        },
        finishRenderLoading() {
            this.$nextTick(() => {
                this.setRenderLoading(false)
            })
        },
        waitForChartVisible(refNames, retryCount = 30) {
            return new Promise(resolve => {
                const check = count => {
                    const visible = refNames.every(refName => {
                        const el = this.$refs[refName]
                        return el && el.clientWidth > 0 && el.clientHeight > 0
                    })
                    if (visible || count <= 0) {
                        resolve(visible)
                        return
                    }
                    requestAnimationFrame(() => check(count - 1))
                }
                check(retryCount)
            })
        },
        buildMotorFeatureRow(label, key, unit, formatter) {
            const motor = this.getMechResult()
            const alarm = this.cndjInfo && this.cndjInfo.Motor_Alarm_level && this.cndjInfo.Motor_Alarm_level.Motor && this.cndjInfo.Motor_Alarm_level.Motor[key]
            const hasValue = motor && motor[key] !== null && motor[key] !== undefined && motor[key] !== ''
            const rawValue = hasValue ? motor[key] : ''
            const value = hasValue ? `${formatter ? formatter(rawValue) : rawValue}${unit}` : '-'
            return {
                label,
                key,
                hasValue,
                value,
                level: alarm && alarm.level,
                statusDirection: this.getRangeDirection(hasValue ? (formatter ? formatter(rawValue) : rawValue) : null, alarm),
                range: this.formatMotorRange(alarm, unit)
            }
        },
        getRangeDirection(value, alarm) {
            if (value === null || value === undefined || value === '' || !alarm) {
                return ''
            }
            const num = Number(value)
            if (Number.isNaN(num)) {
                return ''
            }
            const min = alarm.warn_min !== null && alarm.warn_min !== undefined && alarm.warn_min !== '' ? Number(alarm.warn_min) : null
            const max = alarm.warn_max !== null && alarm.warn_max !== undefined && alarm.warn_max !== '' ? Number(alarm.warn_max) : null
            if (max !== null && !Number.isNaN(max) && num > max) {
                return 'up'
            }
            if (min !== null && !Number.isNaN(min) && num < min) {
                return 'down'
            }
            return ''
        },
        formatMotorRange(alarm, unit) {
            if (!alarm) return ''
            const min = alarm.warn_min !== null && alarm.warn_min !== undefined ? alarm.warn_min : '-'
            const max = alarm.warn_max !== null && alarm.warn_max !== undefined ? alarm.warn_max : '-'
            return `(${min}~${max}${unit.trim()})`
        },
        findMinMax(arr) {
            if (!Array.isArray(arr) || arr.length === 0) {
            return { min: null, max: null };
            }
            let item = Number(arr[0])
            let min = item;
            let max = item;
            for (let i = 1; i < arr.length; i++) {
            item = Number(arr[i])
            if (item < min) {
                min = item;
            }
            if (item > max) {
                max = item;
            }
            }
            return { min, max };
        },
        formatDate(dateString) {
          return dateString.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})*/, '$1-$2-$3 $4:$5:$6');
        },
        getMechResult(){
          return this.cndjInfo&&this.cndjInfo.Mech_Results&&this.cndjInfo.Mech_Results.Motor
        },
        initChart() {
            if (this.switchChart == null) {
                this.switchChart = echarts.init(this.$refs.switch);
            }
            let _option = JSON.parse(JSON.stringify(this.option))
            _option.xAxis.data = this.setxAxisData(this.cndjInfo.Mech_Motor_I.wave.length, this.cndjInfo.Mech_Motor_I.samplingperiod);
            _option.xAxis.axisLabel.interval = this.getXAxisLabelInterval(_option.xAxis.data.length)
            _option.xAxis.axisLabel.formatter = this.formatXAxisLabel
            _option.tooltip.formatter = (params)=>{
                let res= ''
                if(Array.isArray(params)&&params.length>0){
                res +=  params[0].name+'(s)<br/>'
                for(let i=0;i<params.length;i++){
                    const item = params[i]
                    const mark = item.marker
                    let value = item.value; // 数据值
                    let unit = 'A'; // 这里设置你需要的单位
                    res += `<div
                    ">${mark} ${value}${unit}<div/>`;
                }
                }
                return res;
            }
            _option.series[0].data = this.cndjInfo.Mech_Motor_I.wave;
            let {min, max} = this.findMinMax(_option.series[0].data)
            let rangeY = max - min;
            min = Number((rangeY < 0.05 ? min - 0.05 : min - rangeY * 0.2).toFixed(3))
            max = Number((rangeY < 0.05 ? max + 0.05 : max + rangeY * 0.2).toFixed(3))
            rangeY = max - min;
            const intervalY = rangeY > 0 ? Number((rangeY / 5).toFixed(3)) : 1; // 避免除以零
            _option.yAxis.min = min
            _option.yAxis.max = max
            _option.yAxis.interval = intervalY
            this.switchChart.setOption(_option, true);
            this.chartInstance['switchChart'] = this.switchChart
        },
        getCNDJInfo(){
            this.setRenderLoading(true)
            if (this.switchChart != null) {
                this.switchChart.dispose();
                this.switchChart = null;
                this.cndjInfo = {}
            }
            device.getCNDJInfo({sensor_number:this.dataDetails.sensor_number}).then(res=>{
                this.cndjInfo = JSON.parse(res.data)
                return this.$nextTick()
            }).then(() => {
                return this.waitForChartVisible(['switch'])
            }).then(visible => {
                if (visible) this.initChart();
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.finishRenderLoading()
            })
        },
        getMechDjInfoById(){
            this.setRenderLoading(true)
            if (this.switchChart != null) {
                this.switchChart.dispose();
                this.switchChart = null;
                this.cndjInfo = {}
            }
            device.mechDjInfoById({mech_id: this.dataDetails.sensor_data_id}).then(res => {
                if(JSON.stringify(res.data) != '{}'){
                  this.cndjInfo = res.data
                  return this.$nextTick().then(() => this.waitForChartVisible(['switch'])).then(visible => {
                    if (visible) this.initChart();
                  })
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.finishRenderLoading()
            })
        },
        setxAxisData(len, period) {
            let arr = [];
            for (let i = 0; i < len; i++){
                arr.push(i*period/1000/1000)
            }
            return arr;
        },
        getXAxisLabelInterval(len) {
            const maxLabelCount = 10
            return Math.max(Math.ceil(len / maxLabelCount) - 1, 0)
        },
        formatXAxisLabel(value) {
            const num = Number(value)
            if (Number.isNaN(num)) return value
            return Number(num.toFixed(2)).toString()
        },
        getAlarmStatus(level) {
            if (level === undefined || level === null || level === '') return { label: '正常', class: 'status-normal', icon: '✓' };
            switch(level) {
              case 0: return { label: '正常', class: 'status-normal', icon: '✓' };
              case 1: return { label: '预警', class: 'status-warning', icon: '!' };
              case 2: return { label: '报警', class: 'status-alarm', icon: '✕' };
              default: return { label: '正常', class: 'status-normal', icon: '✓' };
            }
        },
    },
};
</script>

<style lang='less' scoped>
 .switch{
        height:50%;width:100%;
    }
    .content-params{
        padding:0 20px;box-sizing: border-box;
        .title{
            width:100%;text-align: center;
        }
        .details{
            width:100%;text-align:center;
            display: flex;
            flex-wrap: wrap;
            .details-item{
                width:33%;
                display: flex; line-height: 30px;
                // justify-content: space-evenly;
                border:solid 1px #666;
                margin-top:15px;
                .item-label{
                    width:50%;
                    border-right:solid 1px #666;
                }
                .item-label-m{
                    width:50%;
                }
                .item-value{
                    width:100%;height:30px;
                    background:#666
                }
            }

        }
    }
.content-title{
    color:white;
    margin:8px;
    text-align:center;
    font-weight: 700;
    font-size: 20px;
}
.item-tips {
    text-align: center;
    color:rgb(191, 191, 191)
} 
.item-value-wrapper {
    width: 50%;
    min-height: 30px;
    background: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.value-row {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    gap: 8px;
    height: 30px;
    line-height: 30px;
}
.value-row .item-value {
    flex-shrink: 0;
    white-space: nowrap;
}
.value-row .status-dot {
    flex-shrink: 0;
}
.range-arrow {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 20px;
    font-weight: 900;
    line-height: 14px;
}
.range-arrow-up {
    color: #f5222d;
}
.range-arrow-up::before {
    content: "↑";
}
.range-arrow-down {
    color: #f5222d;
}
.range-arrow-level-1 {
    color: #faad14;
}
.range-arrow-level-2 {
    color: #f5222d;
}
.range-arrow-down::before {
    content: "↓";
}
.range-row {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #ffffff;
    font-size: 13px;
}
.status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 6px currentColor;
}
.status-normal {
    background-color: #52c41a;
    color: #52c41a;
}
.status-warning {
    background-color: #faad14;
    color: #faad14;
}
.status-alarm {
    background-color: #f5222d;
    color: #f5222d;
}
  .item-range {
    width: 33%;
    padding-left: 10px;
    color: #999;
}
.pane-content {
    display: flex;
    gap: 16px;
    height: calc(100vh - 150px);
    min-height: 620px;
    padding: 0 16px;
    box-sizing: border-box;
}
.content-params {
    width: 620px;
    min-width: 620px;
    flex-basis: 620px;
    flex-shrink: 0;
    overflow-y: auto;
}
.content-chart {
    flex: 1;
    min-width: 0;
    height: 100%;
}
.switch {
    height: 100%;
}
.content-params > .details {
    display: none;
}
.feature-panel {
    padding-top: 8px;
}
.feature-title {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
}
.feature-table {
    width: 100%;
    border-collapse: collapse;
    color: #fff;
    table-layout: fixed;
    font-size: 13px;
}
.feature-table th,
.feature-table td {
    border: 1px solid #666;
    padding: 8px 6px;
    text-align: center;
    vertical-align: middle;
}
.feature-table th {
    background: #3f3f3f;
    font-weight: 700;
}
.feature-table td {
    background: #575757;
}
.feature-table td:first-child {
    width: 42%;
    background: #4a4a4a;
}
.table-value {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 18px;
    white-space: nowrap;
}
.table-range {
    margin-top: 4px;
    color: #ddd;
    font-size: 12px;
    line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/site/cndj.vue